import { render, staticRenderFns } from "./appointmentDetail.vue?vue&type=template&id=4af4283f&scoped=true"
import script from "./appointmentDetail.vue?vue&type=script&lang=js"
export * from "./appointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./appointmentDetail.vue?vue&type=style&index=0&id=4af4283f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4283f",
  null
  
)

export default component.exports